import type { PosthogEventType } from "@repo/app-types/client/client";
import { posthog, type Properties } from "posthog-js";

/** The single Admin boundary for manually captured product analytics events. */
export function captureAnalyticsEvent(
  event: PosthogEventType,
  properties?: Properties,
) {
  if (import.meta.env.DEV) {
    console.debug("[analytics]", event, properties ?? {});
  }

  return posthog.capture(event, properties);
}
